import * as React from "react";
import { Box, BoxProps } from "@mui/material";
import palette from "../../../styles/palette";
import { theme } from "../../../theme";

type NotchedCardProps = BoxProps & {
  borderColor?: string;
};
const NotchedCard = React.forwardRef<HTMLDivElement, NotchedCardProps>(
  ({ borderColor, sx, ...props }, ref) => (
    <Box
      ref={ref}
      data-slot="notched-card"
      sx={{
        position: "relative",
        border: `2px solid ${borderColor ?? palette.border.primary}`, // TODO: DD - move these pallete values to mui theme
        borderRadius: "5px",
        margin: "10px",
        ...sx,
      }}
      {...props}
    />
  )
);
NotchedCard.displayName = "NotchedCard";


type NotchedCardLabelProps = BoxProps & {
  center?: boolean;
};
const NotchedCardLabel = React.forwardRef<HTMLDivElement, NotchedCardLabelProps>(
  ({ center, sx, ...props }, ref) => (
    <Box
      ref={ref}
      component="div"
      data-slot="notched-card-label"
      sx={{
        position: "absolute",
        left: center ? "50%" : "10px",
        top: "-15px",
        backgroundColor: "rgb(255, 255, 255)",
        color: theme.palette.brand.main,
        fontSize: "1.25rem", // 20px
        fontWeight: 700,
        paddingLeft: "10px",
        paddingRight: "10px",
        lineHeight: "initial",
        ...(center && {
          transform: "translateX(-50%)",
        }),
        ...sx,
      }}
      {...props}
    />
  )
);
NotchedCardLabel.displayName = "NotchedCardLabel";


type NotchedCardContentProps = BoxProps;
const NotchedCardContent = React.forwardRef<HTMLDivElement, NotchedCardContentProps>(
  ({ sx, ...props }, ref) => (
    <Box
      ref={ref}
      data-slot="notched-card-content"
      sx={{
        padding: "24px",
        overflow: "auto",
        textAlign: "left",
        ...sx,
      }}
      {...props}
    />
  )
);
NotchedCardContent.displayName = "NotchedCardContent";

export { NotchedCard, NotchedCardLabel, NotchedCardContent };